import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { MANAGER_PERMISSION } from 'dashboard/constants/permissions';

export function useManager() {
  const currentAccount = useMapGetter('getCurrentAccount');
  const { isAdmin } = useAdmin();

  const hasManagerPermission = computed(() =>
    (currentAccount.value?.permissions || []).includes(MANAGER_PERMISSION)
  );
  const isManager = computed(
    () => !isAdmin.value && hasManagerPermission.value
  );
  const isManagerOrAdmin = computed(() => isAdmin.value || isManager.value);

  return {
    isManager,
    isManagerOrAdmin,
  };
}
